import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SolrSanitizer } from '../../shared/solr-sanitizer.util';


@Injectable()
export class SearchResultsService {

  private readonly ngUnSubscribe = new Subject<any>();
  ngUnSubscribe$ = this.ngUnSubscribe.asObservable();

  constructor(
    private readonly http: HttpClient) {
  }


  private readonly endpointURL_search_service_bulletins = 'solr-search/sib?searchTerm=';
  private readonly endpointURL_search_tri_bulletins = 'solr-search/tri?searchTerm=';
  private readonly endpointURL_search_obd = 'solr-search/obd?searchTerm=';
  private readonly endpointURL_search_operating_fluids = 'solr-search/operatingFluid?searchTerm=';
  private readonly endpointURL_search_parts_bulletins = 'solr-search/pbs?searchTerm=';
  private readonly endpointURL_search_technical_documentation = 'solr-search/techDoc?searchTerm=';
  private readonly endpointURL_search_equipment_manuals = 'solr-search/eqManual?searchTerm=';
  private readonly endpointURL_search_tools = 'solr-search/tool?searchTerm=';
  private readonly endpointURL_search_topLinks = 'solr-search/topLink?searchTerm=';
  private readonly endpointURL_search_faqs = 'solr-search/faq?searchTerm=';
  private readonly endpointURL_search_body_and_paint_manuals = 'solr-search/body-and-paint?searchTerm=';
  private readonly endpointURL_search_tech_training_manuals = 'solr-search/ttm?searchTerm=';
  private readonly endpointURL_series_to_body = 'search-result/series2body';


  getBulletinsServiceData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_service_bulletins + sanitizedQuery, { withCredentials: true }).pipe(
    );
  }
  getPartsBulletinsData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_parts_bulletins + sanitizedQuery, { withCredentials: true });
  }
  getTRIBulletinsData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_tri_bulletins + sanitizedQuery, { withCredentials: true });
  }
  getToolsData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_tools + sanitizedQuery, { withCredentials: true });
  }
  getEquipementManualsData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_equipment_manuals + sanitizedQuery, { withCredentials: true });
  }
  getTechnicalDocumentationData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_technical_documentation + sanitizedQuery, { withCredentials: true });
  }
  getBodyAndPaintManualsData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_body_and_paint_manuals + sanitizedQuery, { withCredentials: true });
  }
  getTechTrainingManualsData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_tech_training_manuals + sanitizedQuery, { withCredentials: true });
  }
  getTopLinksData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_topLinks + sanitizedQuery, { withCredentials: true });
  }
  getFAQsData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_faqs + sanitizedQuery, { withCredentials: true });
  }
  getOperatingFluidsData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_operating_fluids + sanitizedQuery, { withCredentials: true });
  }
  getOBDData(queryString: string): Observable<any> {
    if (!SolrSanitizer.isValidSearchTerm(queryString)) {
      throw new Error('Invalid search term');
    }
    const sanitizedQuery = SolrSanitizer.sanitizeSearchTerm(queryString);
    return this.http.get(this.endpointURL_search_obd + sanitizedQuery, { withCredentials: true });
  }
  getSeriesToBody(): Observable<any> {
    return this.http.get(this.endpointURL_series_to_body, { withCredentials: true });
  }

}
